// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--2f5e5";
export var headingContainer = "index-module--heading-container--128a7";
export var highlight = "index-module--highlight--5d2c2";
export var highlightLine = "index-module--highlight-line--f4a31";
export var image1 = "index-module--image-1--d37f6";
export var image2 = "index-module--image-2--dec6f";
export var imageContainer = "index-module--image-container--ec140";